import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import projects from './Data/projects'
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import PagenotFound from './pages/PagenotFound';
import Portfolio from './pages/Portfolio';
import Navbar from './components/Navbar';
import Navbar2 from './components/Navbar2';
import Footer from './components/Footer';
import Kashima from './pages/Kashima';
import TLWanderer from './pages/TLWanderer';
import ProjectR from './pages/ProjectR';
import SyntaxOTD from './pages/SyntaxOTD';
import LOFSuit from './pages/LOFSuit';

function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
}

function AppContent({ toggleDarkMode, isDarkMode }) {
    const location = useLocation();
    const isPortfolio = location.pathname === '/portfolio';
    const isProjectDetail = location.pathname.startsWith('/projects/');
    const showSidebar = !isProjectDetail;

    return (
        <div className={`flex ${isDarkMode ? 'dark' : ''}`}>
            {/* Sidebar - Only show when NOT on ProjectDetail */}
            {!isProjectDetail && (
                <div className="fixed top-0 left-0 h-full">
                    {isPortfolio ? (
                        <Navbar2 toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
                    ) : (
                        <Navbar toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
                    )}
                </div>
            )}

            {/* Navbar2 - Only visible on ProjectDetail pages (no sidebar) */}
            {isProjectDetail && (
                <div className="fixed top-0 left-0 w-full z-50">
                    <Navbar2 toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
                </div>
            )}

            {/* Page Content - Adjust margins based on layout */}
            <div className={`flex-1 p-6 transition-all duration-300 ${showSidebar ? 'mt-[4rem] md:mt-0 md:ml-[250px]' :
                isProjectDetail ? 'pt-[4rem]' : ''
                }`}>
                <ScrollToTop />

                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/projects/kashima" element={<Kashima />} />
                    <Route path="/projects/The-Lost-Wanderer" element={<TLWanderer />} />
                    <Route path="/projects/Leap-of-faith-suit" element={<LOFSuit />} />
                    <Route path="/projects/Project-R" element={<ProjectR />} />
                    <Route path="/projects/Syntax-Of-The-Dead" element={<SyntaxOTD />} />
                    <Route path="/portfolio" element={<Portfolio projects={projects} />} />
                    <Route path="*" element={<PagenotFound />} />
                </Routes>

                {/*<Footer />*/}
            </div>
        </div>
    );
}
function App() {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const stored = localStorage.getItem('theme');
        if (stored === null) return true;
        return stored === 'dark';
    });

    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            document.body.style.backgroundColor = '#202023';
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            document.body.style.backgroundColor = '#ededed';
            localStorage.setItem('theme', 'light');
        }
    }, [isDarkMode]);



    const toggleDarkMode = () => {
        setIsDarkMode((prevMode) => !prevMode);
    };

    return (
        <BrowserRouter>
            <AppContent toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
        </BrowserRouter>
    );
}

export default App;
